module.exports = "/dist/3a371ee0d175f5c2b15ce1d6b981dc4e.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-300.woff
// module id = 116
// module chunks = 0